define(["./monitoringOccurrenceOverviewModule"], function (module) {
    "use strict";

    return module.controller("monitoringOccurrenceOverviewController", [
        "$scope",
        function ($scope) {
            $scope.currentDashboard =   {
                dashboardSourceId: ""
            };
        }]);
});